import { Injectable } from '@angular/core';

@Injectable()
export class LMLocaleUtilService {
  public readonly name = 'en-US';		// en-US is default
  public readonly calendarName = 'gregorian';

  // landmark meta (en-US)
  public readonly decimal = '.';
  public readonly group = '';
  public readonly minusSign = '-';

  // calendar meta for landmark storage formats
  public readonly calendar = {
    // only YYYYMMDD and MMDD have default values of zeros; all others are empty string
    YYYYMMDD: { pattern: 'yyyyMMdd', defaultValue: '00000000' },  // Date
    TIME: { pattern: 'HHmmss', defaultValue: '' },                // Time
    MMDD: { pattern: 'MMdd', defaultValue: '0000' },              // Anniversary
    YYYYMM: { pattern: 'yyyyMM', defaultValue: '' },              // Period
    YYYY: { pattern: 'yyyy', defaultValue: '' },                  // Year

    // pattern needs to be formatted manually with UTC
    TIMESTAMP : { pattern: 'yyyyMMddHHmmssff', defaultValue: '' } // TimeStamp
  };
}
